import { endPoint } from './base.config';

export const voucherPaymentsBasket = {
  update: endPoint + 'voucherPaymentsBaskets/:basketUUID',
  getByBasketUUID: endPoint + 'voucherPaymentsBaskets/getByBasketUUID',
  getVoucherPaymentsByBasketUUID: endPoint + 'voucherPaymentsBaskets/getVoucherPaymentsByBasketUUID',
}
